
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/validar",
      function () {
        return require("private-next-pages/validar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/validar"])
      });
    }
  